var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 18.5581H12.5916C8.89164 18.5581 7.10831 17.0997 6.79997 13.8331C6.76664 13.4914 7.01664 13.1831 7.36664 13.1497C7.69997 13.1164 8.01664 13.3747 8.04997 13.7164C8.29164 16.3331 9.52497 17.3081 12.6 17.3081H12.7083C16.1 17.3081 17.3 16.1081 17.3 12.7164V7.28307C17.3 3.89141 16.1 2.69141 12.7083 2.69141H12.6C9.50831 2.69141 8.27497 3.68307 8.04997 6.34974C8.00831 6.69141 7.71664 6.94974 7.36664 6.91641C7.01664 6.89141 6.76664 6.58307 6.79164 6.24141C7.07497 2.92474 8.86664 1.44141 12.5916 1.44141H12.7C16.7916 1.44141 18.5416 3.19141 18.5416 7.28307V12.7164C18.5416 16.8081 16.7916 18.5581 12.7 18.5581Z",
    fill: "#425466"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 10.625H3.0166C2.67493 10.625 2.3916 10.3417 2.3916 10C2.3916 9.65833 2.67493 9.375 3.0166 9.375H12.4999C12.8416 9.375 13.1249 9.65833 13.1249 10C13.1249 10.3417 12.8416 10.625 12.4999 10.625Z",
    fill: "#425466"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87491 13.4167C4.71658 13.4167 4.55824 13.3584 4.43324 13.2334L1.64158 10.4417C1.39991 10.2 1.39991 9.80003 1.64158 9.55837L4.43324 6.7667C4.67491 6.52503 5.07491 6.52503 5.31658 6.7667C5.55824 7.00837 5.55824 7.40837 5.31658 7.65003L2.96658 10L5.31658 12.35C5.55824 12.5917 5.55824 12.9917 5.31658 13.2334C5.19991 13.3584 5.03324 13.4167 4.87491 13.4167Z",
    fill: "#425466"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ebd95bf01c3fa371474e6ef99040da79.svg";
export { ForwardRef as ReactComponent };